$(window).on('load', function () {
    var headerWrap = $('.stickyNav');
    var headerHeight = $('.header').outerHeight();
    var auxHeight = $('.header-aux').outerHeight();
    var activateHeight = (headerHeight * 2) + auxHeight;
    var fadeHeight = (headerHeight * 4) + auxHeight;
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5; // Minimum scroll difference to register movement

    $(window).scroll(function () {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250); // Reduced interval for better responsiveness

    function hasScrolled() {
        var scrollTop = $(window).scrollTop();

        // Ignore tiny scroll changes (prevents flickering)
        if (Math.abs(lastScrollTop - scrollTop) <= delta) {
            return;
        }

        if (scrollTop > lastScrollTop) {
            // User is scrolling down
            headerWrap.removeClass(' __sticky __navFade').addClass(' __loggedInAdjust');
        } else {
            // User is scrolling up
            if (scrollTop < 46) {
                headerWrap.removeClass('__loggedInAdjust __sticky __navFade');
            }
            else if ((scrollTop >= 46) && (scrollTop < activateHeight)) {
                headerWrap.removeClass('__sticky __navFade');
            } 
            else if ((scrollTop >= activateHeight) && (scrollTop < fadeHeight)) {
                headerWrap.addClass('__navFade');
            }
            else {
                headerWrap.addClass('__sticky').removeClass('__navFade');
            }
        }

        lastScrollTop = scrollTop; // Update last scroll position
    }
});